module.exports = __webpack_public_path__ + "fonts/icomoon.b84c20c.woff";